<div class="container_filter">
    <div class="header">
      <div class="title-description">
        <h2 class="filter-title">
          {{ "quotations_and_orders.orders_filter.title" | translate }}
        </h2>
        <p class="filter-description">
          {{ "filter.description" | translate }}
        </p>
      </div>
      <button class="close" (click)="close()">
        <img src="assets/icones/close.svg" alt="" />
      </button>
    </div>
  
    <div class="content">
      <div class="selection">
        <div class="import-and-selected">
          <ng-container *ngIf="ordersFilters?.filters?.length > 0">
            <button class="select-saved-filter" [matMenuTriggerFor]="menu">
              <img src="assets/icones/import-filter.svg" alt="" />
              <small>{{ "filter.import" | translate }}</small>
            </button>
            <mat-menu #menu="matMenu" class="import-menu">
              <div class="filter_btn"
                *ngFor="let filter of ordersFilters?.filters || []"
                
              >
                <span (click)="setFilter(filter)"
                >{{ filter.name }}</span>
                <button (click)="deleteFilter(filter)" >
                  <img src="assets/icones/delete_btn.svg" alt="">
                </button>
              </div>
            </mat-menu>
          </ng-container>
          <div class="applied-filters-count" (click)="clearFilters()">
            <span class="count">{{ getFiltersCount() }}</span>
            <span>{{ "filter.applied" | translate }}</span>
            <img src="assets/icones/clear-filter.svg" alt="" />
          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'orders_info'"
        >
          <div class="group-title" (click)="selectedGroup = 'orders_info'">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "quotations_and_orders.orders_filter.groups.orders_info" | translate }}</h3>
          </div>
          <div class="filters">
            <div class="filter" *ngIf="filter.generalInfoFilter.name">
              <span>
                {{ "quotations_and_orders.filter.fields.id_order" | translate }} :
                {{ filter.generalInfoFilter.name }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.generalInfoFilter.name = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.generalInfoFilter.order_status">
              <span>
                {{ "quotations_and_orders.shipping_status" | translate }} :
                {{
                  "quotations_and_orders.OrderShippingStatus." + filter.generalInfoFilter.order_status
                    | translate
                }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.generalInfoFilter.order_status = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.generalInfoFilter.payment_status">
              <span>
                {{ "quotations_and_orders.orders_filter.fields.payment_status" | translate }} :
                {{
                  "quotations_and_orders.PaymentStatus." + filter.generalInfoFilter.payment_status
                    | translate
                }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.generalInfoFilter.payment_status = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.generalInfoFilter.catalogs.length > 0">
              <span>
                {{ "quotations_and_orders.filter.fields.catalogs" | translate }} :
                {{ getCatalogsNames() }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.generalInfoFilter.catalogs = []"
              />
            </div>
            <div class="filter" *ngIf="filter.ownershipFilter?.my_orders">
              <span>{{ "quotations_and_orders.orders_filter.fields.my_orders" | translate }}</span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.ownershipFilter!.my_orders = false"
              />
            </div>
            <div class="filter" *ngIf="filter.ownershipFilter?.owner">
              <span>
                {{ "quotations_and_orders.orders_filter.fields.filter_owner" | translate }} :
                {{ filter.ownershipFilter!.owner!.name }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="clearOwnerFilter()"
              />
            </div>
            <div class="filter" *ngIf="filter.ownershipFilter?.creator">
              <span>
                {{ "quotations_and_orders.orders_filter.fields.filter_creator" | translate }} :
                {{ filter.ownershipFilter!.creator!.name }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="clearCreatorFilter()"
              />
            </div>
          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'advenced'"
        >
          <div class="group-title" (click)="selectedGroup = 'advenced'">
            <img src="assets/icones/inventory.svg" alt="" />
            <h3>{{ "quotations_and_orders.orders_filter.groups.advenced" | translate }}</h3>
          </div>
          <div class="filters">
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.total_SKU_min || filter.advancedFilter.total_SKU_max
            "
          >
            <span>
              {{
                "quotations_and_orders.filter.fields.total_sku_min" | translate
              }} :
              <ng-container *ngIf="filter.advancedFilter.total_SKU_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.total_SKU_min }} 
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.total_SKU_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.total_SKU_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.total_SKU_min = undefined;
                filter.advancedFilter.total_SKU_max = undefined
              "
            />
          </div>
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.total_Qty_min || filter.advancedFilter.total_Qty_max
            "
          >
            <span>
              {{
                "quotations_and_orders.filter.fields.total_quantity_min" | translate
              }} :
              <ng-container *ngIf="filter.advancedFilter.total_Qty_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.total_Qty_min }} 
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.total_Qty_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.total_Qty_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.total_Qty_min = undefined;
                filter.advancedFilter.total_Qty_max = undefined
              "
            />
          </div>
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.total_price_min || filter.advancedFilter.total_price_max
            "
          >
            <span>
              {{
                "quotations_and_orders.filter.fields.total_price_min" | translate
              }} :
              <ng-container *ngIf="filter.advancedFilter.total_price_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.total_price_min }} €
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.total_price_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.total_price_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.total_price_min = undefined;
                filter.advancedFilter.total_price_max = undefined
              "
            />
          </div>
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.est_margin_min || filter.advancedFilter.est_margin_max
            "
          >
            <span>
              {{
                "quotations_and_orders.orders_filter.fields.est_margin_min" | translate
              }} :
              <ng-container *ngIf="filter.advancedFilter.est_margin_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.est_margin_min }} 
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.est_margin_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.est_margin_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.est_margin_min = undefined;
                filter.advancedFilter.est_margin_max = undefined
              "
            />
          </div>
            <div
            class="filter"
            *ngIf="
              filter.advancedFilter.date_order_min || filter.advancedFilter.date_order_max
            "
          >
            <span>
              {{
                "quotations_and_orders.orders_filter.fields.date_order_min" | translate
              }} :
              <ng-container *ngIf="filter.advancedFilter.date_order_min">
                {{ "common.from" | translate }}
                {{ filter.advancedFilter.date_order_min }} 
              </ng-container>
              <ng-container *ngIf="filter.advancedFilter.date_order_max">
                {{ "common.to" | translate }}
                {{ filter.advancedFilter.date_order_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.advancedFilter.date_order_min = undefined;
                filter.advancedFilter.date_order_max = undefined
              "
            />
          </div>
          </div>
        </div>
 
       
      </div>
      <div class="form">
        <ng-container *ngIf="selectedGroup === 'orders_info'">
          <div class="form-title">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "quotations_and_orders.orders_filter.groups." + selectedGroup | translate }}</h3>
          </div>
  
          <div class="inputs">
            <div class="field">
              <label for="id_order">{{
                "quotations_and_orders.filter.fields.id_order" | translate
              }}</label>
              <input
                id="id_order"
                type="text"
                [(ngModel)]="filter.generalInfoFilter.name"
                [placeholder]="'quotations_and_orders.filter.fields.id_order' | translate"
              />
            </div>
            <div class="field">
              <label for="">{{
                "quotations_and_orders.shipping_status" | translate
              }}</label>
              <select [(ngModel)]="filter.generalInfoFilter.order_status">
                <option value="" disabled selected>
                  {{ "quotations_and_orders.shipping_status" | translate }}
                </option>
                <option value="unfulfilled">
                  {{ "quotations_and_orders.OrderShippingStatus.unfulfilled" | translate }}
                </option>
                <option value="partially_fulfilled">
                  {{ "quotations_and_orders.OrderShippingStatus.partially_fulfilled" | translate }}
                </option>
        
                <option value="on_hold">
                  {{ "quotations_and_orders.OrderShippingStatus.on_hold" | translate }}
                </option>
                <option value="scheduled">
                  {{ "quotations_and_orders.OrderShippingStatus.scheduled" | translate }}
                </option>
                <option value="picked">
                  {{ "quotations_and_orders.OrderShippingStatus.picked" | translate }}
                </option>
                <option value="packed">
                  {{ "quotations_and_orders.OrderShippingStatus.packed" | translate }}
                </option>
                <option value="shipped">
                  {{ "quotations_and_orders.OrderShippingStatus.shipped" | translate }}
                </option>
                <option value="processing">
                  {{ "quotations_and_orders.OrderShippingStatus.processing" | translate }}
                </option>
        
                <option value="in_transit">
                  {{ "quotations_and_orders.OrderShippingStatus.in_transit" | translate }}
                </option>
                <option value="pending">
                  {{ "quotations_and_orders.OrderShippingStatus.pending" | translate }}
                </option>
                <option value="started">
                  {{ "quotations_and_orders.OrderShippingStatus.started" | translate }}
                </option>
                <option value="partial">
                  {{ "quotations_and_orders.OrderShippingStatus.partial" | translate }}
                </option>
                <option value="full">
                  {{ "quotations_and_orders.OrderShippingStatus.full" | translate }}
                </option>
                <option value="canceled">
                  {{ "quotations_and_orders.OrderShippingStatus.canceled" | translate }}
                </option>
                <option value="returned">
                  {{ "quotations_and_orders.OrderShippingStatus.returned" | translate }}
                </option>
        
                <option value="failed">
                  {{ "quotations_and_orders.OrderShippingStatus.failed" | translate }}
                </option>
        
              </select>
            </div>
            <div class="field">
              <label for="">{{
                "quotations_and_orders.orders_filter.fields.payment_status" | translate
              }}</label>
              <select [(ngModel)]="filter.generalInfoFilter.payment_status">
                <option value="" disabled selected>
                  {{ "quotations_and_orders.orders_filter.fields.payment_status" | translate }}
                </option>
                <option value="not paid">
                  {{ "quotations_and_orders.PaymentStatus.not paid" | translate }}
                </option>
                <option value="in payment">
                  {{ "quotations_and_orders.PaymentStatus.in payment" | translate }}
                </option>
                <option value="paid">
                  {{ "quotations_and_orders.PaymentStatus.paid" | translate }}
                </option>
                <option value="partial">
                  {{ "quotations_and_orders.PaymentStatus.partial" | translate }}
                <option value="reversed">
                  {{ "quotations_and_orders.PaymentStatus.reversed" | translate }}
                </option>
              </select>
            </div>
         
            <div class="field equality_field">
              <label for="">{{
                "quotations_and_orders.filter.fields.catalogs" | translate
              }}</label>
              <mat-chip-list #catalogsChipList>
                <mat-chip
                  *ngFor="
                    let catalog of filter.generalInfoFilter.catalogs;
                    index as i
                  "
                  (removed)="filter.generalInfoFilter.catalogs.splice(i, 1)"
                >
                  {{ catalog.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'quotations_and_orders.filter.fields.catalogs' | translate"
                  #fruitInput
                  (input)="filterCatalogs()"
                  [(ngModel)]="catalogFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="catalogsAutoComplete"
                  [matChipInputFor]="catalogsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #catalogsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filterCatalogs$ | async as catalogs">
                  <mat-option
                    *ngFor="let catalog of catalogs"
                    [value]="catalog.id"
                    (click)="selectCatalog(catalog)"
                  >
                    {{ catalog.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div class="field ownership-field" *ngIf="filter.ownershipFilter">
              <label class="my-orders-check-button">
                <input
                  type="checkbox"
                  [(ngModel)]="filter.ownershipFilter.my_orders"
                  [ngModelOptions]="{ standalone: true }"
                />
                <span class="my-orders-check-button__ui">
                  <span class="my-orders-check-button__mark" aria-hidden="true"></span>
                  <span class="my-orders-check-button__text">{{
                    "quotations_and_orders.orders_filter.fields.my_orders" | translate
                  }}</span>
                </span>
              </label>
            </div>
            <div class="field user-search-field" *ngIf="filter.ownershipFilter">
              <label for="filter_owner_user">{{
                "quotations_and_orders.orders_filter.fields.filter_owner" | translate
              }}</label>
              <div class="user-search-row">
                <input
                  id="filter_owner_user"
                  type="text"
                  [formControl]="ownerSearchInput"
                  [matAutocomplete]="ownerUserAuto"
                  [placeholder]="'quotations_and_orders.orders_filter.fields.user_search_placeholder' | translate"
                />
                <button
                  type="button"
                  class="user-search-clear"
                  *ngIf="filter.ownershipFilter.owner"
                  (click)="clearOwnerFilter()"
                >
                  ×
                </button>
              </div>
              <mat-autocomplete #ownerUserAuto="matAutocomplete" (optionSelected)="onOwnerSelected($event)">
                <mat-option *ngFor="let u of ownerOptions" [value]="u">
                  {{ u.name }}<span *ngIf="u.email" class="user-opt-email"> — {{ u.email }}</span>
                </mat-option>
              </mat-autocomplete>
              <span class="user-search-hint" *ngIf="ownerSearchLoading">{{ "common.loading" | translate }}</span>
            </div>
            <div class="field user-search-field" *ngIf="filter.ownershipFilter">
              <label for="filter_creator_user">{{
                "quotations_and_orders.orders_filter.fields.filter_creator" | translate
              }}</label>
              <div class="user-search-row">
                <input
                  id="filter_creator_user"
                  type="text"
                  [formControl]="creatorSearchInput"
                  [matAutocomplete]="creatorUserAuto"
                  [placeholder]="'quotations_and_orders.orders_filter.fields.user_search_placeholder' | translate"
                />
                <button
                  type="button"
                  class="user-search-clear"
                  *ngIf="filter.ownershipFilter.creator"
                  (click)="clearCreatorFilter()"
                >
                  ×
                </button>
              </div>
              <mat-autocomplete #creatorUserAuto="matAutocomplete" (optionSelected)="onCreatorSelected($event)">
                <mat-option *ngFor="let u of creatorOptions" [value]="u">
                  {{ u.name }}<span *ngIf="u.email" class="user-opt-email"> — {{ u.email }}</span>
                </mat-option>
              </mat-autocomplete>
              <span class="user-search-hint" *ngIf="creatorSearchLoading">{{ "common.loading" | translate }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedGroup === 'advenced'">
          <div class="form-title">
            <img src="assets/icones/inventory.svg" alt="" />
            <h3>{{ "quotations_and_orders.orders_filter.groups." + selectedGroup | translate }}</h3>
          </div>
          <div class="inputs">
            <div class="inputs-pair">
              <div class="field">
                <label for="total_SKU_min">{{
                  "quotations_and_orders.filter.fields.total_sku_min" | translate
                }}</label>
                <input
                  id="total_SKU_min"
                  type="number"
                  min="0"
                  [max]="filter.advancedFilter.total_SKU_max || 1"
                  [(ngModel)]="filter.advancedFilter.total_SKU_min"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_sku_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="total_SKU_max">{{
                  "quotations_and_orders.filter.fields.total_sku_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.advancedFilter.total_SKU_min || 0"
                  [(ngModel)]="filter.advancedFilter.total_SKU_max"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_sku_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="total_Qty_min">{{
                  "quotations_and_orders.filter.fields.total_quantity_min" | translate
                }}</label>
                <input
                  id="total_Qty_min"
                  type="number"
                  min="0"
                  [max]="filter.advancedFilter.total_Qty_max || 1"
                  [(ngModel)]="filter.advancedFilter.total_Qty_min"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_quantity_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="total_Qty_max">{{
                  "quotations_and_orders.filter.fields.total_quantity_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.advancedFilter.total_Qty_min || 0"
                  [(ngModel)]="filter.advancedFilter.total_Qty_max"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_quantity_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="total_price_min">{{
                  "quotations_and_orders.filter.fields.total_price_min" | translate
                }}</label>
                <input
                  id="total_price_min"
                  type="number"
                  min="0"
                  [max]="filter.advancedFilter.total_price_max || 1"
                  [(ngModel)]="filter.advancedFilter.total_price_min"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_price_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="total_price_max">{{
                  "quotations_and_orders.filter.fields.total_price_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.advancedFilter.total_price_min || 0"
                  [(ngModel)]="filter.advancedFilter.total_price_max"
                  [placeholder]="
                    'quotations_and_orders.filter.fields.total_price_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="est_margin_min">{{
                  "quotations_and_orders.orders_filter.fields.est_margin_min" | translate
                }}</label>
                <input
                  id="est_margin_min"
                  type="number"
                  min="0"
                  [max]="filter.advancedFilter.est_margin_max || 1"
                  [(ngModel)]="filter.advancedFilter.est_margin_min"
                  [placeholder]="
                    'quotations_and_orders.orders_filter.fields.est_margin_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="est_margin_max">{{
                  "quotations_and_orders.orders_filter.fields.est_margin_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.advancedFilter.est_margin_min || 0"
                  [(ngModel)]="filter.advancedFilter.est_margin_max"
                  [placeholder]="
                    'quotations_and_orders.orders_filter.fields.est_margin_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="date_order_min">{{
                  "quotations_and_orders.orders_filter.fields.date_order_min" | translate
                }}</label>
                    <input
                    id="date_order_min"
                    type="date"
                    [(ngModel)]="filter.advancedFilter.date_order_min"
                    [placeholder]="'quotations_and_orders.orders_filter.fields.date_order_min' | translate"
                    />
              </div>
              <div class="field">
                <label for="date_order_max">{{
                  "quotations_and_orders.orders_filter.fields.date_order_max" | translate
                }}</label>
                  <input
                  id="date_order_max"
                  type="date"
                  [(ngModel)]="filter.advancedFilter.date_order_max"
                  [placeholder]="'quotations_and_orders.orders_filter.fields.date_order_max' | translate"
                  />
              </div>
          </div>
          </div>
        </ng-container>
  
      </div>
    </div>
  
    <div class="footer submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
          <span>{{"common.cancel"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <div class="save-apply">
        <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
          <div class="label-action">
            <label for="filter_name">{{
              "filter.filter_name" | translate
            }}</label>
            <div class="actions">
              <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
              <button class="save-btn" (click)="save()">
                {{ "common.save" | translate | uppercase }}
              </button>
            </div>
          </div>
          <input
            id="filter_name"
            type="text"
            class="filter-name-input"
            [placeholder]="'filter.filter_name' | translate"
            [(ngModel)]="filterName"
            [formControl]="filterNameControl"
          />
          <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
            {{ "common.required_field" | translate }}
          </span>
        </div>
        <button
          class="save save_filter"
          [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm"
          (click)="toggleSaveFilter()"
        >
          <img src="assets/icones/save-filter.svg" alt="" />
          <small>{{ "filter.save" | translate }}</small>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="apply()">
          <small>{{ "filter.apply" | translate | uppercase }}</small>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
    </div>
  </div>
  